export const translateStatus = {
  Paused: "Pausado",
  Active: "Ativo",
  Deleted: "Removido",
  Draft: "Rascunho",
  done: "Concluído"
}